import { l as f } from "../../../_virtual/leaflet-src.js";
import { createLayerComponent as c } from "../../@react-leaflet/core/lib/generic.js";
import { createElementObject as l } from "../../@react-leaflet/core/lib/element.js";
import { extendContext as o } from "../../@react-leaflet/core/lib/context.js";
const y = c(function({ position: e, ...t }, n) {
  const i = new f.Marker(e, t);
  return l(i, o(n, {
    overlayContainer: i
  }));
}, function(e, t, n) {
  t.position !== n.position && e.setLatLng(t.position), t.icon != null && t.icon !== n.icon && e.setIcon(t.icon), t.zIndexOffset != null && t.zIndexOffset !== n.zIndexOffset && e.setZIndexOffset(t.zIndexOffset), t.opacity != null && t.opacity !== n.opacity && e.setOpacity(t.opacity), e.dragging != null && t.draggable !== n.draggable && (t.draggable === !0 ? e.dragging.enable() : e.dragging.disable());
});
export {
  y as Marker
};
